import { render, staticRenderFns } from "./phase.vue?vue&type=template&id=2dd31b50&scoped=true&"
import script from "./phase.vue?vue&type=script&lang=js&"
export * from "./phase.vue?vue&type=script&lang=js&"
import style0 from "./phase.vue?vue&type=style&index=0&id=2dd31b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd31b50",
  null
  
)

export default component.exports